
import { Inertia } from '@inertiajs/inertia'
import HandlesInertiaExceptions from './HandlesInertiaExceptions'

export default {
  mixins: [
    HandlesInertiaExceptions,
  ],

  methods: {
    showInertiaException (message) {
      this.$store.dispatch('alert/showWarning', message)
    },
    logout () {
      Inertia.delete('')
    },
  },
}
